import { MetricFilters } from "@/services/metrics";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, RotateCcw } from "lucide-react";

interface MetricsFiltersProps {
  filters: MetricFilters;
  onChange: (filters: MetricFilters) => void;
  onApply: () => void;
}

export function MetricsFilters({ filters, onChange, onApply }: MetricsFiltersProps) {
  const handleReset = () => {
    onChange({ from: "", to: "", period: undefined });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 flex flex-wrap gap-4 items-end shadow-sm">
      <div className="flex flex-col gap-1.5 min-w-[140px]">
        <Label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Desde
        </Label>
        <input
          type="date"
          value={filters.from || ""}
          onChange={(e) => onChange({ ...filters, from: e.target.value })}
          className="h-9 rounded-lg border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 text-foreground"
        />
      </div>

      <div className="flex flex-col gap-1.5 min-w-[140px]">
        <Label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Hasta
        </Label>
        <input
          type="date"
          value={filters.to || ""}
          onChange={(e) => onChange({ ...filters, to: e.target.value })}
          className="h-9 rounded-lg border border-input bg-background px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 text-foreground"
        />
      </div>

      <div className="flex flex-col gap-1.5 min-w-[130px]">
        <Label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Período
        </Label>
        <Select
          value={filters.period || ""}
          onValueChange={(val) =>
            onChange({ ...filters, period: val === "all" ? undefined : (val as "daily" | "monthly") })
          }
        >
          <SelectTrigger className="h-9 text-sm">
            <SelectValue placeholder="Todos" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="daily">Diario</SelectItem>
            <SelectItem value="monthly">Mensual</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex gap-2 pb-0.5">
        <Button onClick={onApply} size="sm" className="h-9 gap-1.5">
          <Search className="h-3.5 w-3.5" />
          Aplicar
        </Button>
        <Button onClick={handleReset} size="sm" variant="outline" className="h-9 gap-1.5">
          <RotateCcw className="h-3.5 w-3.5" />
          Limpiar
        </Button>
      </div>
    </div>
  );
}
